import { Link } from "gatsby"
import React, { useEffect } from "react"
import { graphql, useStaticQuery } from "gatsby"
import { useLocation } from "@reach/router"
import ROUTES from '../../routes.js'

import { connect } from "react-redux"

import {
  getPropertiesAction,
  getTotalListFilters,
  REDUX_UPDATE_FILTERS,
} from "../redux/propertiesDucks"
// import { getDevelopmentsAction } from "../redux/developmentsDucks"

import {
  existOperation,
  existDevelopment,
  makeItemsNav,
} from "../helpers/helper.rendering"
import { getOperationView } from "../helpers/helper.filters"

import { getNoveltiesAction } from "../redux/noveltiesDucks"
import { getActionsAction } from "../redux/actionsDucks"
import { useGetBlogsQuery } from '../redux/mediacore/blog'
import { useGetDevelopmentsQuery } from '../redux/middlewareTokkoApi/developments'
import { useGetTotalFiltersQuery } from '../redux/originalTokkoApi/properties'
import { useGetConfigurationsQuery } from '../redux/mediacore/configuration'
import useQueryDevelopments from "../hooks/useQueryDevelopments.js"
import useQuerySummary from "../hooks/useQuerySummary.js"
import { useGetJobsQuery } from "../redux/mediacore/jobs.js"

const MenuNav = ({
  filters,
  curFilters,
  api_key,
  // developments,
  dispatch,
  setOpen,
}) => {
  const { realEstate } = useStaticQuery(graphql`
    query {
      realEstate {
        template_version
        keys {
          tokko
        }
        design {
          icons
        }
        global_phone
        global_email
        global_broker_id
        global_phone
        social {
          facebook
          instagram
          linkedin
          youtube
          twitter
        }
        branch_office {
          name
          address
          city
          region
          broker_id

          contact {
            phone
            mail
            whatsapp
          }
        }
        env {
          APISERVER
          TENANTID
          CLIENTID
        }
        sections {
          footer {
            title_contact
            title_social
            title_newsletter
            title_office
            button_contact {
              link
              value
            }
          }
        }
      }
    }
  `)


  const { design: { icons }, env, template_version, keys } = realEstate
  const iconsStyle =icons === "Solid" || icons === "Light" ? `-${icons.toLowerCase()}` : ""
  const MediaPro = template_version === "PRO" ? true : false
  const location = useLocation()
  const pathname = location.pathname.split("/")[1]

  const { data: modules } = useGetConfigurationsQuery(env.CLIENTID);
  const { data: allBlogData } = useGetBlogsQuery(env.CLIENTID);

  const { data: allJobsData } = useGetJobsQuery(env.CLIENTID);

  // const { data: allDevelopmentsData } = useGetDevelopmentsQuery(keys.tokko);
  const { allDevelopmentsData } = useQueryDevelopments()

  const { allSummaryData: allSummaryData, isLoading: isLoadingAllTokkoFilters } = useQuerySummary();

  const INVESTOR_CONFIGURATION = modules?.find(config => config.module === "INVESTOR")
  const OWNER_CONFIGURATION = modules?.find(config =>config.module === "OWNER")
  const hasModules = (INVESTOR_CONFIGURATION?.module || OWNER_CONFIGURATION?.module)?.length > 0;

  useEffect(() => {
    if (api_key) {
      // // dispatch(getTotalListFilters())
    }
  }, [api_key])

  const staticBody = () => {
    var body = document.body
    body.classList.remove("overflow-hidden")
  }

  const checkActive = _pathname => {
    if(_pathname === TEMPORARY.route && curFilters.operation === TEMPORARY.route && pathname === TEMPORARY.route){
      return true;
    }
    if(_pathname === RENT.route && curFilters.operation === RENT.route && pathname === RENT.route){
      return true;

    }
    if(_pathname === SALE.route && curFilters.operation === SALE.route && pathname === SALE.route){
      return true;

    }

    if (_pathname === "emprendimientos" && pathname === "emprendimientos") {
      if (location.pathname.length > 20) {
        return false
      }
    }
    if (_pathname === "inicio" && pathname === "") {
      return true
    }
    if (
      curFilters.operation === TEMPORARY.route &&
      _pathname === TEMPORARY.route
    ) {
      return true
    }
    else{
      if (
        ((_pathname === "venta" ||
          (_pathname === "alquiler" && _pathname !== TEMPORARY.route)) &&
          pathname.includes("venta")) ||
          pathname.includes("alquiler")
      ) {
        if (curFilters.operation === "alquiler" && _pathname === "alquiler") {
          // return true
        }
        if (curFilters.operation === "venta" && _pathname === "venta") {
          // return true
        }
      } else {
        if (pathname === _pathname && _pathname !== TEMPORARY.route) {
          return true
        }
      }
    }
    return false
  }

  const fillFilters = (item) => {
      return {
          location: [],
          type: [],
          operation: item === TEMPORARY.name ? TEMPORARY.route : item,
          environments:'',
          bedrooms:'',
          address:'',
          price:{
            type:'',
            priceMin:'',
            priceMax:''
          },
          surface:{
            type:'',
            surfaceMin:"",
            surfaceMax:"",
          },
          environments_types: [],
          generals: [],
          services: [],
          specials: [],
        }
  }


  const { SALE_VIEW_DATA: SALE, RENT_VIEW_DATA: RENT, TEMPORARY_VIEW_DATA: TEMPORARY } = JSON.parse(process.env.extra_data || ROUTES);
  
  return realEstate.sections ? (
    <nav className="nav-content opened d-flex align-items-center">
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-8 pe-xl-5" style={{ alignSelf: "center" }}>
            <ul className="nav-menu d-flex flex-column d-lg-block">
              {makeItemsNav(allDevelopmentsData, allSummaryData, allBlogData?.news, MediaPro, allJobsData).map(
                (item, index) => (
                  <li
                    className={
                      checkActive(item.name.toLowerCase()) ? "active" : ""
                    }
                  >
                    {item.name === RENT.name ||
                    item.name === SALE.name ||
                    item.name === TEMPORARY.name ? (
                      <a
                        className={
                          "text-uppercase is-a " +
                          (checkActive(item.name.toLowerCase()) ? "active" : "")
                        }
                        href={item.link}
                      >
                        {item.name}{" "}
                        <span>
                          {index < 9 ? "0" : ""}
                          {index + 1}
                        </span>
                      </a>
                    ) : !checkActive(item.name.toLowerCase()) ? (
                      <Link
                        onClick={() =>
                          staticBody() +
                          (item.name.toLowerCase() === SALE.name ||
                          item.name.toLowerCase() === RENT.name ||
                          item.name.toLowerCase() === TEMPORARY.name
                            ? dispatch(
                                REDUX_UPDATE_FILTERS(
                                  fillFilters(item.route),
                                  item.route
                                )
                              ) +
                              setOpen(false)
                              //  +
                              // dispatch(getPropertiesAction())
                            : dispatch(
                                REDUX_UPDATE_FILTERS(
                                  fillFilters(SALE.route),
                                  SALE.route
                                )
                              ))
                        }
                        className={
                          "text-uppercase " +
                          (checkActive(item.name.toLowerCase()) ? "active" : "")
                        }
                        to={item.link}
                      >
                        {item.name}{" "}
                        <span>
                          {index < 9 ? "0" : ""}
                          {index + 1}
                        </span>
                      </Link>
                    ) : (
                      <div
                        className="text-uppercase"
                        onClick={() => staticBody() + setOpen(false)}
                      >
                        {item.name}{" "}
                        <span>
                          {index < 9 ? "0" : ""}
                          {index + 1}
                        </span>
                      </div>
                    )}
                  </li>
                )
              )}
            </ul>
            {/* Investor & Owner - Mobile */}
            <div
                className={
                  "item-contact row mb-0 button-separator text-center private-access-container " +
                  ((INVESTOR_CONFIGURATION?.module || OWNER_CONFIGURATION?.module) ? "d-block d-lg-none" : " d-none")
                }
              >
                <h5 className="private-access">ACCESOS PRIVADOS</h5>
                {INVESTOR_CONFIGURATION?.module &&<div className="d-block">
                  <a
                    className="btn btn-investor mb-2 d-block d-lg-inline-block"
                    target={"_blank"}
                    href={
                      INVESTOR_CONFIGURATION.url_login
                    }
                  >
                    {INVESTOR_CONFIGURATION.text_cta || "INVERSORES"}
                  </a>
                </div>}
                {OWNER_CONFIGURATION?.module &&<div className="d-block">
                  <a
                    className="btn btn-investor mb-2 d-block d-lg-inline-block"
                    target={"_blank"}
                    href={
                      OWNER_CONFIGURATION.url_login
                    }
                  >
                    {OWNER_CONFIGURATION.text_cta || "PROPIETARIOS"}
                  </a>
                </div>}
            </div>
          </div>
          <div className="col-lg-4 px-xl-5 contact-nav d-none d-lg-flex align-items-center">
            <div className="row">
              <div className={"col-12" + (hasModules ? " max-heigth-scroll up-to-52" : "")}>
                <div className="row">
                  <div className="item-contact col-8 col-lg-12">
                    <h5>{realEstate.sections.footer.title_contact}</h5>
                    <a
                      className="hover-service-link "
                      target="_blank"
                      href={"mailto:" + realEstate.global_email}
                    >
                      {realEstate.global_email}
                    </a>
                    {realEstate?.global_phone?.map(phone => (
                      <p
                        className={"mb-0 mb-lg-0 " + (phone === "" ? "d-none" : "")}
                      >
                        Teléfono {phone}
                      </p>
                    ))}
                    {realEstate?.global_broker_id.map((broker, index) => (
                      <p className={"mb-0 mb-lg-0 " + (broker === " " && "d-none")}>
                        {broker}
                      </p>
                    ))}
                  </div>
                  {realEstate.branch_office.map((item, index) => (
                    <div className="item-contact mb-lg-5 mt-lg-4 d-none d-lg-block col-12" key={index}>
                      <h5>
                        {realEstate.sections.footer.title_office + " "}
                        {item.name}
                      </h5>
                      <p>{item.address}</p>
                      <p>{item.region}</p>
                      <a
                        target="_blank"
                        className={
                          "hover-link " + (!item.contact.mail && "d-none")
                        }
                        href={"mailto:" + item.contact.mail}
                      >
                        {item.contact.mail}
                      </a>
                      {item.contact.phone.map(phone => (
                        <p>Teléfono {phone}</p>
                      ))}
                      {item.contact.whatsapp.map(whatsapp => (
                        <a
                          className={"hover-footer-link"}
                          target="_blank"
                          href={
                            "https://api.whatsapp.com/send?" +
                            "phone=" +
                            whatsapp.replaceAll(" ", "").replaceAll("-","").replaceAll("+","")
                          }
                        >
                          Whatsapp {whatsapp}
                        </a>
                      ))}
                      <p className={item.broker_id === "" && "d-none"}>
                        Matrícula {item.broker_id}
                      </p>
                    </div>
                  ))}
                  <div className="item-contact mb-lg-5 mt-0 social col-4 col-lg-12">
                    <h5>{realEstate.sections.footer.title_social}</h5>
                    <a
                      target="_blank"
                      href={realEstate.social.instagram}
                      class={realEstate.social.instagram ? "d-inline" : "d-none"}
                    >
                      <i class={`icon-instagram${iconsStyle}`}></i>
                    </a>
                    <a
                      target="_blank"
                      href={realEstate.social.facebook}
                      class={realEstate.social.facebook ? "d-inline" : "d-none"}
                    >
                      <i class={`icon-facebook${iconsStyle}`}></i>
                    </a>
                    <a
                      target="_blank"
                      href={realEstate.social.linkedin}
                      class={realEstate.social.linkedin ? "d-inline" : "d-none"}
                    >
                      <i class={`icon-linkedin${iconsStyle}`}></i>
                    </a>
                    <a
                      target="_blank"
                      href={realEstate.social.youtube}
                      class={realEstate.social.youtube ? "d-inline" : "d-none"}
                    >
                      <i class={`icon-youtube${iconsStyle}`}></i>
                    </a>
                    <a
                      target="_blank"
                      href={realEstate.social.twitter}
                      class={realEstate.social.twitter ? "d-inline" : "d-none"}
                    >
                      <i class={`icon-twitter${iconsStyle}`}></i>
                    </a>
                  </div>
                </div>
              </div>
              { hasModules ? <div className="col-12 mt-lg-4">
                {/* Investor & Owner - Desktop */}
                <div
                  className={
                    "item-contact row mb-0 button-separator " +
                    ((INVESTOR_CONFIGURATION?.module || OWNER_CONFIGURATION?.module) ? "d-block" : " d-none")
                  }
                >
                  <h5 className="">ACCESOS PRIVADOS</h5>
                  {INVESTOR_CONFIGURATION?.module &&<div className="d-block">
                    <a
                      className="btn btn-investor mb-2 d-block d-lg-inline-block"
                      target={"_blank"}
                      href={
                        INVESTOR_CONFIGURATION.url_login
                      }
                    >
                      {INVESTOR_CONFIGURATION.text_cta || "INVERSORES"}
                    </a>
                  </div>}
                  { OWNER_CONFIGURATION?.module &&<div className="d-block">
                    <a
                      className="btn btn-investor mb-2 d-block d-lg-inline-block"
                      target={"_blank"}
                      href={
                        OWNER_CONFIGURATION.url_login
                      }
                    >
                      {OWNER_CONFIGURATION.text_cta || "PROPIETARIOS"}
                    </a>
                  </div>}
                </div>
              </div> : null }
            </div>
          </div>
        </div>
      </div>
    </nav>
  ) : (
    ""
  )
}

export default connect(
  state => ({
    filters: state.properties.totalListFilters,
    curFilters: state.properties.filters,
    novelties: state.novelties.grid_novelties,
    api_key: state.settings.keys.tokko,
    // developments: state.developments.developments,
  }),
  null
)(MenuNav)
